<template>
  <div class="consultant-panel">
    <div class="panel-content">
      <div class="title-section">
        <h2 class="main-title">添加专属顾问</h2>
        <p class="subtitle">免费获取 多重权益</p>
      </div>

      <div class="qrcode-section">
        <div class="qrcode-container">
          <img
            :src="withBase('/images/contact_me_qr_20260821.png')"
            alt="专属顾问微信二维码"
            class="qrcode-image"
          />
        </div>
      </div>

      <div class="benefits-section">
        <div v-for="benefit in benefits" :key="benefit.label" class="benefit-item">
          <div class="benefit-icon">
            <SvgIcon :name="benefit.icon" size="24" aria-hidden="true" />
          </div>
          <span class="benefit-label">{{ benefit.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { withBase } = useBasePath()

const benefits = [
  { label: '专属顾问', icon: 'consultant-user' },
  { label: '方案支持', icon: 'consultant-design' },
  { label: '避坑指南', icon: 'consultant-explore' },
  { label: '工具赋能', icon: 'consultant-tool' },
]
</script>

<style lang="scss" scoped>
.consultant-panel {
  background: $bg-white;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 12px;

  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0 10px 10px 10px;
    border-style: solid;
    border-color: transparent transparent $bg-white transparent;
    z-index: 1;
  }
}

.panel-content {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.title-section {
  text-align: center;
  margin-bottom: 12px;
}

.main-title {
  font-size: 20px;
  font-weight: 600;
  color: $text-title-color;
  margin: 0 0 4px;
  line-height: 28px;
}

.subtitle {
  font-size: 14px;
  color: $text-content-color;
  margin: 0;
  line-height: 22px;
}

.qrcode-section {
  text-align: center;
  margin-bottom: 12px;
}

.qrcode-container {
  width: 180px;
  height: 180px;
  margin: 0 auto;
  background-color: $bg-white;
  border-radius: 8px;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.benefits-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
}

.benefit-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 48px;
  min-width: 0;
  gap: $spacing-xs;
}

.benefit-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: $bg-color;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $text-content-color;
}

.benefit-label {
  font-size: 12px;
  line-height: 18px;
  color: $text-content-color;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

@include respond-to-max('lg') {
  .panel-content {
    padding: 0;
  }

  .title-section {
    padding: 24px 16px;
    margin-bottom: 0;
  }

  .main-title {
    font-size: $font-size-card-title;
  }

  .subtitle {
    font-size: $font-size-card-content;
  }

  .qrcode-section {
    padding: 0 20px;
    margin-bottom: 24px;
  }

  .qrcode-container {
    width: 200px;
    height: 200px;
  }

  .benefits-section {
    padding: 0 20px 24px;
    gap: $spacing-sm;
  }

  .benefit-item {
    gap: $spacing-xs;
  }

  .benefit-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .benefit-label {
    font-size: 12px;
  }
}
</style>
